export const config = {
    "API_URL": process.env.PUBLIC_URL
};